"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "convertRemToPx", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.convertRemToPx;
  }
});
Object.defineProperty(exports, "defaultCssProps", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.defaultCssProps;
  }
});
Object.defineProperty(exports, "display", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.display;
  }
});
Object.defineProperty(exports, "fontFamily", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.fontFamily;
  }
});
Object.defineProperty(exports, "heading", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.heading;
  }
});
Object.defineProperty(exports, "paragraph", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.paragraph;
  }
});
Object.defineProperty(exports, "themeName", {
  enumerable: true,
  get: function get() {
    return _typographyConfig.themeName;
  }
});
var _typographyConfig = require("./typography-config");